"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiClient = void 0;
const index_1 = require("../constants/index");
const index_2 = require("../interface/index");
const axios_1 = __importDefault(require("axios"));
const helperFunction_1 = require("./helperFunction");
/**
 * Creates an axios client instance configured with the provided algolia appID and API key.
 *
 * @param {string} appId - The application ID for the Algolia API.
 * @param {string} apiKey - The API key for authentication with the Algolia API.
 * @returns {Object} An object containing methods to interact with the API, including 'popularSearch'.
 */
const apiClient = (appId, apiKey) => {
    const instance = axios_1.default.create({
        timeout: 10000,
        headers: {
            "x-algolia-api-key": apiKey,
            "x-algolia-application-id": appId,
        },
    });
    return {
        /**
         * Fetches popular search data from the algolia analytics API.
         *
         * @param {Object} params - The parameters for the popular search request.
         * @param {string} params.indexName - The name of the index to search in.
         * @param {number} [params.daysFromToday=30] - The number of days in the past to consider for the search (defaults to 30).
         * @param {number} [params.offset=0] - The offset for pagination (defaults to 0).
         * @param {number} [params.limit=10] - The number of results to return (defaults to 10).
         * @param {PopularSearchEvents} [params.eventType=PopularSearchEvents.searchCount] - The event type to order by (defaults to searchCount).
         * @param {string} [params.direction="desc"] - The sort direction for the results (defaults to "desc").
         * @param {boolean} [params.revenueAnalytics=false] - Whether to include revenue analytics (defaults to false).
         * @param {boolean} [params.clickAnalytics=false] - Whether to include click analytics (defaults to false).
         * @returns {Promise} The axios GET request promise for fetching the popular search data.
         */
        popularSearch: ({ indexName, daysFromToday = 30, offset = 0, limit = 10, eventType = index_2.PopularSearchEvents.searchCount, direction = "desc", revenueAnalytics = false, clickAnalytics = false, }) => {
            const endDate = (0, helperFunction_1.getFormattedDate)();
            let startDate = new Date();
            startDate.setDate(startDate.getDate() - +daysFromToday);
            startDate = (0, helperFunction_1.getFormattedDate)(new Date(startDate));
            return instance.get(index_1.ApiEndpoints.POPULAR_SEARCH, {
                params: {
                    index: indexName,
                    offset,
                    limit,
                    startDate: startDate,
                    endDate,
                    orderBy: eventType,
                    direction,
                    revenueAnalytics,
                    clickAnalytics,
                },
            });
        },
    };
};
exports.apiClient = apiClient;
